module.exports = {"610222001":"宜阳街道","610222101":"彭镇","610222102":"五里镇","610222103":"太安镇","610222104":"棋盘镇","610222105":"尧生镇","610222106":"哭泉镇","610222201":"云梦乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610222.json
// module id = 2929
// module chunks = 0